import { render } from "./App.vue?vue&type=template&id=2e546aef&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e546aef&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=2e546aef&lang=scss"

import exportComponent from "D:\\work\\lcyhqqxx\\new-student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e546aef"]])

export default __exports__